import React, { useState } from "react";
import {
  NavLink,
  Link,
  useParams,
  useLocation,
  useNavigate,
} from "react-router-dom";
import "../AgentSideBar/AgentSideBar.css";
import { useEffect } from "react";
import { showSuccessToast } from "../../../assets/toastUtils";
import logoimg from "../../../assets/images/Mountain-mystries-logo.png";
import logout from "../../../assets/new-images/logout.png";

const AgentSideBar = () => {
  const [dropdown, setDropdown] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const [logOutPopup, setLogOutPopup] = useState(false);
  const handleOpenDropdown = () => {
    setDropdown((prevState) => !prevState);
  };

  // useEffect(() => {
  //   const isActive =
  //     location.pathname.startsWith("/partner/rates/") ||
  //     location.pathname.startsWith("/partner/inventory/");
  //   setDropdown(isActive);
  // }, [location.pathname]);

  useEffect(() => {
    if (
      location.pathname.startsWith("/partner/rates/") ||
      location.pathname.startsWith("/partner/inventory/")
    ) {
      setDropdown(true);
    } else {
      setDropdown(false);
    }
  }, []);

  const { id } = useParams();
  // console.log(id);

  const handleLogout = async (e) => {
    e.preventDefault();

    navigate("/");
    localStorage.clear();
    showSuccessToast("Logged Out Successful");
  };

  return (
    <>
      <section className="sidebar">
        {/* <h4>Menu</h4> */}

        <div className="flex justify_content_center mt-10">
          <NavLink className="Header-icon" to="/" exact>
            <img src={logoimg} alt="logo-image" className="logo" />
          </NavLink>
        </div>
        <small className="small_text">MENU</small>
        <NavLink
          className="sidebar_btn flex align_items_center flex_gap_5"
          to={`/agent-dashboard`}
        >
          <span className="active_bg_color"></span>
          <span className="sidebar_btn_icon_text">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="21"
              viewBox="0 0 20 21"
              fill="none"
            >
              <mask
                id="mask0_6855_8514"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="20"
                height="21"
              >
                <rect y="0.5" width="20" height="20" fill="#D9D9D9" />
              </mask>
              <g mask="url(#mask0_6855_8514)">
                <path
                  d="M4.42443 17.5833C4.00345 17.5833 3.64714 17.4375 3.35547 17.1458C3.0638 16.8542 2.91797 16.4978 2.91797 16.0769V4.92311C2.91797 4.50214 3.0638 4.14582 3.35547 3.85416C3.64714 3.56249 4.00345 3.41666 4.42443 3.41666H15.5782C15.9992 3.41666 16.3555 3.56249 16.6471 3.85416C16.9388 4.14582 17.0846 4.50214 17.0846 4.92311V16.0769C17.0846 16.4978 16.9388 16.8542 16.6471 17.1458C16.3555 17.4375 15.9992 17.5833 15.5782 17.5833H4.42443ZM4.42443 16.3333H9.3763V4.66666H4.42443C4.36026 4.66666 4.30151 4.69339 4.24818 4.74686C4.19471 4.8002 4.16797 4.85895 4.16797 4.92311V16.0769C4.16797 16.141 4.19471 16.1998 4.24818 16.2531C4.30151 16.3066 4.36026 16.3333 4.42443 16.3333ZM10.6263 16.3333H15.5782C15.6423 16.3333 15.7011 16.3066 15.7544 16.2531C15.8079 16.1998 15.8346 16.141 15.8346 16.0769V10.5H10.6263V16.3333ZM10.6263 9.24999H15.8346V4.92311C15.8346 4.85895 15.8079 4.8002 15.7544 4.74686C15.7011 4.69339 15.6423 4.66666 15.5782 4.66666H10.6263V9.24999Z"
                  fill="#888888"
                />
              </g>
            </svg>
            Dashboard
          </span>
        </NavLink>

        <NavLink
          className="sidebar_btn flex align_items_center flex_gap_5"
          to={`/agent-search`}
        >
          <span className="active_bg_color"></span>
          <span className="sidebar_btn_icon_text">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="21"
              viewBox="0 0 20 21"
              fill=""
            >
              <mask
                id="mask0_6855_8508"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="20"
                height="21"
              >
                <rect y="0.5" width="20" height="20" fill="#D9D9D9" />
              </mask>
              <g mask="url(#mask0_6855_8508)">
                <path
                  d="M7.91667 13.8333C6.40278 13.8333 5.12153 13.309 4.07292 12.2604C3.02431 11.2118 2.5 9.93056 2.5 8.41667C2.5 6.90278 3.02431 5.62153 4.07292 4.57292C5.12153 3.52431 6.40278 3 7.91667 3C9.43056 3 10.7118 3.52431 11.7604 4.57292C12.809 5.62153 13.3333 6.90278 13.3333 8.41667C13.3333 9.02778 13.2361 9.60417 13.0417 10.1458C12.8472 10.6875 12.5833 11.1667 12.25 11.5833L16.9167 16.25C17.0694 16.4028 17.1458 16.5972 17.1458 16.8333C17.1458 17.0694 17.0694 17.2639 16.9167 17.4167C16.7639 17.5694 16.5694 17.6458 16.3333 17.6458C16.0972 17.6458 15.9028 17.5694 15.75 17.4167L11.0833 12.75C10.6667 13.0833 10.1875 13.3472 9.64583 13.5417C9.10417 13.7361 8.52778 13.8333 7.91667 13.8333ZM7.91667 12.1667C8.95833 12.1667 9.84375 11.8021 10.5729 11.0729C11.3021 10.3438 11.6667 9.45833 11.6667 8.41667C11.6667 7.375 11.3021 6.48958 10.5729 5.76042C9.84375 5.03125 8.95833 4.66667 7.91667 4.66667C6.875 4.66667 5.98958 5.03125 5.26042 5.76042C4.53125 6.48958 4.16667 7.375 4.16667 8.41667C4.16667 9.45833 4.53125 10.3438 5.26042 11.0729C5.98958 11.8021 6.875 12.1667 7.91667 12.1667Z"
                  fill="#888888"
                />
              </g>
            </svg>
            Search
          </span>
        </NavLink>

        <NavLink
          className="sidebar_btn flex align_items_center  flex_gap_5"
          to={`/agent-booking`}
        >
          <span className="active_bg_color"></span>
          <span className="sidebar_btn_icon_text">
            <svg
              width="20"
              height="21"
              viewBox="0 0 20 21"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <mask
                id="mask0_6964_8144"
                style={{ maskType: "alpha" }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="20"
                height="21"
              >
                <rect y="0.5" width="20" height="20" fill="#D9D9D9" />
              </mask>
              <g mask="url(#mask0_6964_8144)">
                <path
                  d="M9.1263 13.6796L12.1905 10.6154C12.3144 10.4915 12.4637 10.4282 12.6384 10.4254C12.813 10.4228 12.9649 10.4861 13.0942 10.6154C13.2235 10.7447 13.2882 10.8954 13.2882 11.0673C13.2882 11.2392 13.2235 11.3899 13.0942 11.5192L9.65359 14.96C9.5029 15.1106 9.32714 15.1858 9.1263 15.1858C8.92547 15.1858 8.74971 15.1106 8.59901 14.96L6.90839 13.2692C6.7845 13.1453 6.72116 12.996 6.71839 12.8213C6.71575 12.6467 6.77908 12.4947 6.90839 12.3654C7.03769 12.2361 7.18832 12.1715 7.36026 12.1715C7.53221 12.1715 7.68283 12.2361 7.81214 12.3654L9.1263 13.6796ZM4.42443 18.4167C4.00345 18.4167 3.64714 18.2708 3.35547 17.9792C3.0638 17.6875 2.91797 17.3312 2.91797 16.9102V5.75647C2.91797 5.3355 3.0638 4.97918 3.35547 4.68751C3.64714 4.39585 4.00345 4.25001 4.42443 4.25001H5.57818V3.12814C5.57818 2.9455 5.63936 2.793 5.76172 2.67064C5.88408 2.54842 6.03658 2.4873 6.21922 2.4873C6.402 2.4873 6.5545 2.54842 6.67672 2.67064C6.79908 2.793 6.86026 2.9455 6.86026 3.12814V4.25001H13.1744V3.1123C13.1744 2.93494 13.2342 2.7864 13.3538 2.66668C13.4735 2.5471 13.6221 2.4873 13.7994 2.4873C13.9768 2.4873 14.1253 2.5471 14.2448 2.66668C14.3646 2.7864 14.4244 2.93494 14.4244 3.1123V4.25001H15.5782C15.9992 4.25001 16.3555 4.39585 16.6471 4.68751C16.9388 4.97918 17.0846 5.3355 17.0846 5.75647V16.9102C17.0846 17.3312 16.9388 17.6875 16.6471 17.9792C16.3555 18.2708 15.9992 18.4167 15.5782 18.4167H4.42443ZM4.42443 17.1667H15.5782C15.6423 17.1667 15.7011 17.1399 15.7544 17.0865C15.8079 17.0331 15.8346 16.9744 15.8346 16.9102V9.0898H4.16797V16.9102C4.16797 16.9744 4.19471 17.0331 4.24818 17.0865C4.30151 17.1399 4.36026 17.1667 4.42443 17.1667ZM4.16797 7.8398H15.8346V5.75647C15.8346 5.6923 15.8079 5.63355 15.7544 5.58022C15.7011 5.52675 15.6423 5.50001 15.5782 5.50001H4.42443C4.36026 5.50001 4.30151 5.52675 4.24818 5.58022C4.19471 5.63355 4.16797 5.6923 4.16797 5.75647V7.8398Z"
                  fill="#888888"
                />
              </g>
            </svg>
            Bookings
          </span>
        </NavLink>
        {/* <NavLink
          className="sidebar_btn flex align_items_center flex_gap_5"
          to={`/agent-credit-logs`}
        >
          <span className="active_bg_color"></span>
          <span className="sidebar_btn_icon_text">
            {" "}
            <svg
              width="21"
              height="20"
              viewBox="0 0 21 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <mask
                id="mask0_5012_6616"
                style={{ maskType: "alpha" }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="21"
                height="20"
              >
                <rect x="0.5" width="20" height="20" fill="#D9D9D9" />
              </mask>
              <g mask="url(#mask0_5012_6616)">
                <path
                  d="M3.83329 16.6666C3.37496 16.6666 2.9826 16.5034 2.65621 16.177C2.32982 15.8506 2.16663 15.4583 2.16663 14.9999V4.99992C2.16663 4.54159 2.32982 4.14922 2.65621 3.82284C2.9826 3.49645 3.37496 3.33325 3.83329 3.33325H7.99996V4.99992H3.83329V14.9999H17.1666V4.99992H13V3.33325H17.1666C17.625 3.33325 18.0173 3.49645 18.3437 3.82284C18.6701 4.14922 18.8333 4.54159 18.8333 4.99992V14.9999C18.8333 15.4583 18.6701 15.8506 18.3437 16.177C18.0173 16.5034 17.625 16.6666 17.1666 16.6666H3.83329ZM10.5 12.8333L6.33329 8.66659L7.49996 7.49992L9.66663 9.66658V3.33325H11.3333V9.66658L13.5 7.49992L14.6666 8.66659L10.5 12.8333Z"
                  fill="#D9D9D9"
                />
              </g>
            </svg>
            Account Ledger
          </span>
        </NavLink> */}
        {/* <NavLink
          className="sidebar_btn flex align_items_center flex_gap_5 "
          to={`/agent-promotion`}
        >
          <span className="active_bg_color"></span>

          <span className="sidebar_btn_icon_text">
            <svg
              width="20"
              height="21"
              viewBox="0 0 20 21"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <mask
                id="mask0_6855_7769"
                style={{ maskType: "alpha" }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="20"
                height="21"
              >
                <rect y="0.5" width="20" height="20" fill="#D9D9D9" />
              </mask>
              <g mask="url(#mask0_6855_7769)">
                <path
                  d="M6.38625 9.51448C5.65819 9.51448 5.03681 9.25712 4.52208 8.7424C4.00736 8.22781 3.75 7.60642 3.75 6.87823C3.75 6.15017 4.00736 5.52878 4.52208 5.01406C5.03681 4.49948 5.65819 4.24219 6.38625 4.24219C7.11431 4.24219 7.73569 4.49948 8.25042 5.01406C8.76514 5.52878 9.0225 6.15017 9.0225 6.87823C9.0225 7.60642 8.76514 8.22781 8.25042 8.7424C7.73569 9.25712 7.11431 9.51448 6.38625 9.51448ZM6.38583 8.26448C6.77069 8.26448 7.09799 8.12976 7.36771 7.86031C7.63757 7.59087 7.7725 7.26372 7.7725 6.87885C7.7725 6.49385 7.63778 6.16649 7.36833 5.89677C7.09889 5.62705 6.77167 5.49219 6.38667 5.49219C6.00181 5.49219 5.67444 5.62691 5.40458 5.89635C5.13486 6.1658 5 6.49295 5 6.87781C5 7.26281 5.13472 7.59017 5.40417 7.8599C5.67361 8.12962 6.00083 8.26448 6.38583 8.26448ZM13.6219 16.7501C12.8937 16.7501 12.2723 16.4927 11.7577 15.978C11.243 15.4633 10.9856 14.8419 10.9856 14.1139C10.9856 13.3858 11.243 12.7644 11.7577 12.2497C12.2723 11.735 12.8937 11.4776 13.6219 11.4776C14.3499 11.4776 14.9713 11.735 15.486 12.2497C16.0006 12.7644 16.2579 13.3858 16.2579 14.1139C16.2579 14.8419 16.0006 15.4633 15.486 15.978C14.9713 16.4927 14.3499 16.7501 13.6219 16.7501ZM13.6213 15.5001C14.0063 15.5001 14.3336 15.3654 14.6033 15.0959C14.8731 14.8265 15.0079 14.4993 15.0079 14.1143C15.0079 13.7294 14.8732 13.4021 14.6038 13.1324C14.3343 12.8625 14.0072 12.7276 13.6223 12.7276C13.2373 12.7276 12.9099 12.8623 12.6402 13.1318C12.3705 13.4012 12.2356 13.7284 12.2356 14.1134C12.2356 14.4983 12.3703 14.8257 12.6398 15.0955C12.9092 15.3652 13.2364 15.5001 13.6213 15.5001ZM4.26917 16.2309C4.15389 16.1155 4.09625 15.97 4.09625 15.7945C4.09625 15.6189 4.15389 15.4743 4.26917 15.3607L14.8767 4.75344C14.9919 4.63802 15.1356 4.58163 15.3077 4.58427C15.4797 4.58691 15.6233 4.64594 15.7388 4.76135C15.8542 4.87677 15.9119 5.02226 15.9119 5.19781C15.9119 5.37337 15.8542 5.51795 15.7388 5.63156L5.13146 16.2389C5.01604 16.3543 4.87236 16.4107 4.70042 16.408C4.52833 16.4052 4.38458 16.3462 4.26917 16.2309Z"
                  fill="#888888"
                />
              </g>
            </svg>
            Promotions
          </span>
        </NavLink> */}

        <NavLink
          className="sidebar_btn flex align_items_center flex_gap_5"
          to={`/brand-asset`}
        >
          <span className="active_bg_color"></span>
          <span className="sidebar_btn_icon_text">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="21"
              viewBox="0 0 20 21"
              fill="none"
            >
              <mask
                id="mask0_6855_8051"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="20"
                height="21"
              >
                <rect y="0.5" width="20" height="20" fill="#D9D9D9" />
              </mask>
              <g mask="url(#mask0_6855_8051)">
                <path
                  d="M9.98266 18.4167C8.90252 18.4167 7.88224 18.2086 6.92182 17.7925C5.96127 17.3764 5.12259 16.8099 4.40578 16.0929C3.68884 15.3761 3.12231 14.5361 2.7062 13.5729C2.29009 12.6097 2.08203 11.5854 2.08203 10.5C2.08203 9.40069 2.29571 8.36944 2.72307 7.40624C3.15043 6.44305 3.73085 5.6052 4.46432 4.8927C5.19766 4.18006 6.05557 3.61701 7.03807 3.20354C8.02043 2.79006 9.06821 2.58333 10.1814 2.58333C11.2231 2.58333 12.2102 2.76097 13.1429 3.11625C14.0756 3.47152 14.8948 3.96326 15.6004 4.59145C16.3061 5.21965 16.8683 5.96618 17.287 6.83104C17.7059 7.69576 17.9154 8.63347 17.9154 9.64416C17.9154 11.0865 17.4867 12.2147 16.6293 13.0287C15.772 13.8429 14.6729 14.25 13.332 14.25H11.8224C11.5852 14.25 11.3956 14.3274 11.2535 14.4823C11.1114 14.6373 11.0404 14.8206 11.0404 15.0321C11.0404 15.2896 11.1445 15.5572 11.3529 15.835C11.5612 16.1128 11.6654 16.4317 11.6654 16.7917C11.6654 17.3418 11.5131 17.7502 11.2087 18.0169C10.9041 18.2834 10.4954 18.4167 9.98266 18.4167ZM5.41536 11.125C5.71231 11.125 5.96016 11.0256 6.15891 10.8269C6.35766 10.6281 6.45703 10.3803 6.45703 10.0833C6.45703 9.78638 6.35766 9.53854 6.15891 9.33979C5.96016 9.14104 5.71231 9.04166 5.41536 9.04166C5.11842 9.04166 4.87057 9.14104 4.67182 9.33979C4.47307 9.53854 4.3737 9.78638 4.3737 10.0833C4.3737 10.3803 4.47307 10.6281 4.67182 10.8269C4.87057 11.0256 5.11842 11.125 5.41536 11.125ZM7.91536 7.79166C8.21231 7.79166 8.46016 7.69229 8.65891 7.49354C8.85766 7.29479 8.95703 7.04694 8.95703 6.74999C8.95703 6.45305 8.85766 6.2052 8.65891 6.00645C8.46016 5.8077 8.21231 5.70833 7.91536 5.70833C7.61842 5.70833 7.37057 5.8077 7.17182 6.00645C6.97307 6.2052 6.8737 6.45305 6.8737 6.74999C6.8737 7.04694 6.97307 7.29479 7.17182 7.49354C7.37057 7.69229 7.61842 7.79166 7.91536 7.79166ZM12.082 7.79166C12.379 7.79166 12.6268 7.69229 12.8256 7.49354C13.0243 7.29479 13.1237 7.04694 13.1237 6.74999C13.1237 6.45305 13.0243 6.2052 12.8256 6.00645C12.6268 5.8077 12.379 5.70833 12.082 5.70833C11.7851 5.70833 11.5372 5.8077 11.3385 6.00645C11.1397 6.2052 11.0404 6.45305 11.0404 6.74999C11.0404 7.04694 11.1397 7.29479 11.3385 7.49354C11.5372 7.69229 11.7851 7.79166 12.082 7.79166ZM14.582 11.125C14.879 11.125 15.1268 11.0256 15.3256 10.8269C15.5243 10.6281 15.6237 10.3803 15.6237 10.0833C15.6237 9.78638 15.5243 9.53854 15.3256 9.33979C15.1268 9.14104 14.879 9.04166 14.582 9.04166C14.2851 9.04166 14.0372 9.14104 13.8385 9.33979C13.6397 9.53854 13.5404 9.78638 13.5404 10.0833C13.5404 10.3803 13.6397 10.6281 13.8385 10.8269C14.0372 11.0256 14.2851 11.125 14.582 11.125ZM9.98266 17.1667C10.1184 17.1667 10.2244 17.1333 10.3008 17.0665C10.3772 16.9996 10.4154 16.9081 10.4154 16.7917C10.4154 16.5972 10.3112 16.3787 10.1029 16.1362C9.89453 15.8937 9.79036 15.514 9.79036 14.9969C9.79036 14.4028 9.99175 13.9215 10.3945 13.5529C10.7973 13.1843 11.2904 13 11.8737 13H13.332C14.3129 13 15.1136 12.7126 15.7343 12.1379C16.355 11.5631 16.6654 10.7318 16.6654 9.64416C16.6654 7.95833 16.019 6.5684 14.7262 5.47437C13.4336 4.38034 11.9186 3.83333 10.1814 3.83333C8.27654 3.83333 6.65877 4.47916 5.32807 5.77083C3.99738 7.06249 3.33203 8.63888 3.33203 10.5C3.33203 12.3472 3.98134 13.9201 5.27995 15.2187C6.57856 16.5174 8.14613 17.1667 9.98266 17.1667Z"
                  fill="#888888"
                />
              </g>
            </svg>
            Brand Asset
          </span>
        </NavLink>

        {/* <h4>General</h4> */}
        {/* <NavLink
          className="sidebar_btn flex align_items_center flex_gap_5"
          to={`/agent-dashboard`}
        >
          <span className="active_bg_color"></span>
          <span className="sidebar_btn_icon_text">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
              <mask id="mask0_6855_7787" maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="21">
                <rect y="0.5" width="20" height="20" fill="#D9D9D9" />
              </mask>
              <g mask="url(#mask0_6855_7787)">
                <path d="M9.07565 18.4166C8.79148 18.4166 8.54607 18.3223 8.3394 18.1337C8.13259 17.9452 8.00676 17.7131 7.9619 17.4374L7.75836 15.878C7.53516 15.8033 7.30627 15.6987 7.07169 15.5641C6.83725 15.4294 6.62759 15.2851 6.44273 15.1314L4.99877 15.7451C4.73697 15.8605 4.47391 15.8717 4.20961 15.7787C3.94516 15.6858 3.73975 15.517 3.59336 15.2724L2.65419 13.6441C2.5078 13.3995 2.46565 13.1407 2.52773 12.8676C2.58968 12.5947 2.73176 12.3696 2.95398 12.1922L4.20232 11.2547C4.18315 11.1308 4.16954 11.0064 4.16148 10.8814C4.15343 10.7564 4.1494 10.6319 4.1494 10.5078C4.1494 10.3894 4.15343 10.2689 4.16148 10.1466C4.16954 10.0242 4.18315 9.89041 4.20232 9.74513L2.95398 8.80763C2.73176 8.63027 2.591 8.40374 2.53169 8.12804C2.47239 7.85249 2.51593 7.59235 2.66232 7.34763L3.59336 5.74346C3.73975 5.50415 3.94516 5.33672 4.20961 5.24117C4.47391 5.14547 4.73697 5.15534 4.99877 5.27075L6.43461 5.87659C6.63558 5.71742 6.85009 5.57186 7.07815 5.43992C7.30621 5.30797 7.5303 5.20193 7.75044 5.12179L7.9619 3.56242C8.00676 3.28672 8.13259 3.05464 8.3394 2.86617C8.54607 2.67756 8.79148 2.58325 9.07565 2.58325H10.9219C11.2061 2.58325 11.4515 2.67756 11.6581 2.86617C11.865 3.05464 11.9908 3.28672 12.0356 3.56242L12.2392 5.12971C12.4892 5.22054 12.7154 5.32659 12.9177 5.44784C13.1202 5.56909 13.3246 5.712 13.5309 5.87659L15.0069 5.27075C15.2686 5.15534 15.5316 5.14547 15.7961 5.24117C16.0605 5.33672 16.2659 5.50415 16.4121 5.74346L17.3434 7.35575C17.4897 7.60034 17.5319 7.85915 17.4698 8.13221C17.4079 8.40513 17.2658 8.63027 17.0436 8.80763L15.7631 9.76909C15.793 9.90367 15.8093 10.0295 15.8121 10.1466C15.8147 10.2635 15.8161 10.3813 15.8161 10.4999C15.8161 10.6131 15.8134 10.7283 15.8079 10.8453C15.8027 10.9623 15.7835 11.0961 15.7504 11.2468L17.0067 12.1922C17.2289 12.3696 17.3724 12.5947 17.4371 12.8676C17.5017 13.1407 17.4608 13.3995 17.3144 13.6441L16.3704 15.2643C16.2242 15.509 16.0175 15.6778 15.7504 15.7708C15.4834 15.8637 15.2189 15.8524 14.9571 15.737L13.5309 15.1233C13.3246 15.2878 13.1141 15.4334 12.8994 15.5599C12.6847 15.6866 12.4646 15.79 12.2392 15.8701L12.0356 17.4374C11.9908 17.7131 11.865 17.9452 11.6581 18.1337C11.4515 18.3223 11.2061 18.4166 10.9219 18.4166H9.07565ZM9.16544 17.1666H10.8034L11.1029 14.9343C11.5282 14.8232 11.9168 14.6653 12.2688 14.4608C12.6209 14.256 12.9604 13.9929 13.2873 13.6714L15.3577 14.5416L16.1784 13.1249L14.3706 11.7628C14.4401 11.547 14.4873 11.3354 14.5123 11.128C14.5375 10.9208 14.55 10.7114 14.55 10.4999C14.55 10.283 14.5375 10.0736 14.5123 9.87179C14.4873 9.66985 14.4401 9.4636 14.3706 9.25304L16.1942 7.87492L15.3738 6.45825L13.2792 7.34117C13.0003 7.04311 12.6662 6.77978 12.2769 6.55117C11.8875 6.32256 11.4935 6.16068 11.095 6.06554L10.8321 3.83325H9.17836L8.90252 6.05763C8.47739 6.15804 8.08482 6.31186 7.72482 6.51908C7.36468 6.72645 7.02114 6.99353 6.69419 7.32034L4.62377 6.45825L3.80336 7.87492L5.60294 9.21617C5.5335 9.41395 5.48489 9.61964 5.45711 9.83325C5.42933 10.0469 5.41544 10.2717 5.41544 10.5078C5.41544 10.7248 5.42933 10.9374 5.45711 11.1458C5.48489 11.3541 5.53086 11.5598 5.59502 11.7628L3.80336 13.1249L4.62377 14.5416L6.68627 13.6666C7.00252 13.9913 7.34065 14.2573 7.70065 14.4647C8.06079 14.6719 8.45877 14.8311 8.89461 14.9422L9.16544 17.1666ZM10.0084 12.9999C10.7017 12.9999 11.2917 12.7566 11.7784 12.2699C12.265 11.7833 12.5084 11.1933 12.5084 10.4999C12.5084 9.80659 12.265 9.21658 11.7784 8.72992C11.2917 8.24325 10.7017 7.99992 10.0084 7.99992C9.30641 7.99992 8.71426 8.24325 8.2319 8.72992C7.74954 9.21658 7.50836 9.80659 7.50836 10.4999C7.50836 11.1933 7.74954 11.7833 8.2319 12.2699C8.71426 12.7566 9.30641 12.9999 10.0084 12.9999Z" fill="#888888" />
              </g>
            </svg>
            Settings
          </span>
        </NavLink>
        <NavLink
          className="sidebar_btn flex align_items_center flex_gap_5"
          to={`/agent-account`}
        >
          <span className="active_bg_color"></span>
          <span className="sidebar_btn_icon_text">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
              <mask id="mask0_6855_7793" maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="21">
                <rect y="0.5" width="20" height="20" fill="#D9D9D9" />
              </mask>
              <g mask="url(#mask0_6855_7793)">
                <path d="M10.0002 18.4166C8.90516 18.4166 7.87592 18.2088 6.91245 17.7933C5.94898 17.3777 5.11092 16.8137 4.39828 16.1014C3.68564 15.389 3.12141 14.5513 2.70557 13.5883C2.28988 12.6252 2.08203 11.5962 2.08203 10.5014C2.08203 9.40638 2.28981 8.37714 2.70536 7.41367C3.12092 6.4502 3.68488 5.61214 4.39724 4.8995C5.1096 4.18686 5.94731 3.62263 6.91036 3.20679C7.87342 2.7911 8.90238 2.58325 9.99724 2.58325C11.0922 2.58325 12.1215 2.79103 13.0849 3.20658C14.0484 3.62214 14.8865 4.1861 15.5991 4.89846C16.3118 5.61082 16.876 6.44853 17.2918 7.41159C17.7075 8.37464 17.9154 9.4036 17.9154 10.4985C17.9154 11.5935 17.7076 12.6227 17.292 13.5862C16.8765 14.5496 16.3125 15.3877 15.6002 16.1003C14.8878 16.813 14.0501 17.3772 13.087 17.793C12.124 18.2087 11.095 18.4166 10.0002 18.4166ZM7.58203 16.7083L8.80641 13.9197C8.28627 13.7361 7.83731 13.4514 7.45953 13.0658C7.08175 12.6799 6.79356 12.2274 6.59495 11.7083L3.77432 12.8749C4.09918 13.7638 4.59495 14.5416 5.26161 15.2083C5.92828 15.8749 6.70175 16.3749 7.58203 16.7083ZM6.59495 9.29159C6.783 8.77242 7.06745 8.32346 7.44828 7.94471C7.82911 7.56596 8.27648 7.28311 8.79036 7.09617L7.6237 4.27554C6.72953 4.61429 5.94911 5.117 5.28245 5.78367C4.61578 6.45034 4.11307 7.23075 3.77432 8.12492L6.59495 9.29159ZM9.99682 12.8718C10.6552 12.8718 11.2154 12.6414 11.6774 12.1805C12.1395 11.7197 12.3706 11.1601 12.3706 10.5018C12.3706 9.84346 12.1402 9.28325 11.6793 8.82117C11.2185 8.35909 10.6589 8.12804 10.0006 8.12804C9.34224 8.12804 8.78203 8.35846 8.31995 8.81929C7.85786 9.28013 7.62682 9.83971 7.62682 10.498C7.62682 11.1564 7.85724 11.7166 8.31807 12.1787C8.77891 12.6408 9.33849 12.8718 9.99682 12.8718ZM12.4154 16.7083C13.2904 16.3749 14.0577 15.8784 14.7174 15.2187C15.3772 14.5589 15.8737 13.7916 16.207 12.9166L13.4185 11.6922C13.2422 12.2061 12.9629 12.6521 12.5804 13.0303C12.1979 13.4085 11.754 13.6996 11.2487 13.9037L12.4154 16.7083ZM13.4024 9.24992L16.207 8.08325C15.8737 7.20825 15.3772 6.44089 14.7174 5.78117C14.0577 5.12145 13.2904 4.62492 12.4154 4.29159L11.2487 7.12179C11.7433 7.31402 12.1749 7.59395 12.5435 7.96158C12.9121 8.32908 13.1984 8.75853 13.4024 9.24992Z" fill="#888888" />
              </g>
            </svg>
            Help
          </span>
        </NavLink> */}
        <small className="small_text">GENERAL</small>
        <NavLink
          className="sidebar_btn flex align_items_center flex_gap_5"
          to={`/agent-account`}
        >
          <span className="active_bg_color"></span>
          <span className="sidebar_btn_icon_text">
            {" "}
            <svg
              width="20"
              height="21"
              viewBox="0 0 20 21"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <mask
                id="mask0_6855_7787"
                style={{ maskType: "alpha" }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="20"
                height="21"
              >
                <rect y="0.5" width="20" height="20" fill="#D9D9D9" />
              </mask>
              <g mask="url(#mask0_6855_7787)">
                <path
                  d="M9.07565 18.4166C8.79148 18.4166 8.54607 18.3223 8.3394 18.1337C8.13259 17.9452 8.00676 17.7131 7.9619 17.4374L7.75836 15.878C7.53516 15.8033 7.30627 15.6987 7.07169 15.5641C6.83725 15.4294 6.62759 15.2851 6.44273 15.1314L4.99877 15.7451C4.73697 15.8605 4.47391 15.8717 4.20961 15.7787C3.94516 15.6858 3.73975 15.517 3.59336 15.2724L2.65419 13.6441C2.5078 13.3995 2.46565 13.1407 2.52773 12.8676C2.58968 12.5947 2.73176 12.3696 2.95398 12.1922L4.20232 11.2547C4.18315 11.1308 4.16954 11.0064 4.16148 10.8814C4.15343 10.7564 4.1494 10.6319 4.1494 10.5078C4.1494 10.3894 4.15343 10.2689 4.16148 10.1466C4.16954 10.0242 4.18315 9.89041 4.20232 9.74513L2.95398 8.80763C2.73176 8.63027 2.591 8.40374 2.53169 8.12804C2.47239 7.85249 2.51593 7.59235 2.66232 7.34763L3.59336 5.74346C3.73975 5.50415 3.94516 5.33672 4.20961 5.24117C4.47391 5.14547 4.73697 5.15534 4.99877 5.27075L6.43461 5.87659C6.63558 5.71742 6.85009 5.57186 7.07815 5.43992C7.30621 5.30797 7.5303 5.20193 7.75044 5.12179L7.9619 3.56242C8.00676 3.28672 8.13259 3.05464 8.3394 2.86617C8.54607 2.67756 8.79148 2.58325 9.07565 2.58325H10.9219C11.2061 2.58325 11.4515 2.67756 11.6581 2.86617C11.865 3.05464 11.9908 3.28672 12.0356 3.56242L12.2392 5.12971C12.4892 5.22054 12.7154 5.32659 12.9177 5.44784C13.1202 5.56909 13.3246 5.712 13.5309 5.87659L15.0069 5.27075C15.2686 5.15534 15.5316 5.14547 15.7961 5.24117C16.0605 5.33672 16.2659 5.50415 16.4121 5.74346L17.3434 7.35575C17.4897 7.60034 17.5319 7.85915 17.4698 8.13221C17.4079 8.40513 17.2658 8.63027 17.0436 8.80763L15.7631 9.76909C15.793 9.90367 15.8093 10.0295 15.8121 10.1466C15.8147 10.2635 15.8161 10.3813 15.8161 10.4999C15.8161 10.6131 15.8134 10.7283 15.8079 10.8453C15.8027 10.9623 15.7835 11.0961 15.7504 11.2468L17.0067 12.1922C17.2289 12.3696 17.3724 12.5947 17.4371 12.8676C17.5017 13.1407 17.4608 13.3995 17.3144 13.6441L16.3704 15.2643C16.2242 15.509 16.0175 15.6778 15.7504 15.7708C15.4834 15.8637 15.2189 15.8524 14.9571 15.737L13.5309 15.1233C13.3246 15.2878 13.1141 15.4334 12.8994 15.5599C12.6847 15.6866 12.4646 15.79 12.2392 15.8701L12.0356 17.4374C11.9908 17.7131 11.865 17.9452 11.6581 18.1337C11.4515 18.3223 11.2061 18.4166 10.9219 18.4166H9.07565ZM9.16544 17.1666H10.8034L11.1029 14.9343C11.5282 14.8232 11.9168 14.6653 12.2688 14.4608C12.6209 14.256 12.9604 13.9929 13.2873 13.6714L15.3577 14.5416L16.1784 13.1249L14.3706 11.7628C14.4401 11.547 14.4873 11.3354 14.5123 11.128C14.5375 10.9208 14.55 10.7114 14.55 10.4999C14.55 10.283 14.5375 10.0736 14.5123 9.87179C14.4873 9.66985 14.4401 9.4636 14.3706 9.25304L16.1942 7.87492L15.3738 6.45825L13.2792 7.34117C13.0003 7.04311 12.6662 6.77978 12.2769 6.55117C11.8875 6.32256 11.4935 6.16068 11.095 6.06554L10.8321 3.83325H9.17836L8.90252 6.05763C8.47739 6.15804 8.08482 6.31186 7.72482 6.51908C7.36468 6.72645 7.02114 6.99353 6.69419 7.32034L4.62377 6.45825L3.80336 7.87492L5.60294 9.21617C5.5335 9.41395 5.48489 9.61964 5.45711 9.83325C5.42933 10.0469 5.41544 10.2717 5.41544 10.5078C5.41544 10.7248 5.42933 10.9374 5.45711 11.1458C5.48489 11.3541 5.53086 11.5598 5.59502 11.7628L3.80336 13.1249L4.62377 14.5416L6.68627 13.6666C7.00252 13.9913 7.34065 14.2573 7.70065 14.4647C8.06079 14.6719 8.45877 14.8311 8.89461 14.9422L9.16544 17.1666ZM10.0084 12.9999C10.7017 12.9999 11.2917 12.7566 11.7784 12.2699C12.265 11.7833 12.5084 11.1933 12.5084 10.4999C12.5084 9.80659 12.265 9.21658 11.7784 8.72992C11.2917 8.24325 10.7017 7.99992 10.0084 7.99992C9.30641 7.99992 8.71426 8.24325 8.2319 8.72992C7.74954 9.21658 7.50836 9.80659 7.50836 10.4999C7.50836 11.1933 7.74954 11.7833 8.2319 12.2699C8.71426 12.7566 9.30641 12.9999 10.0084 12.9999Z"
                  fill="#888888"
                />
              </g>
            </svg>
            Settings
          </span>
        </NavLink>

        <NavLink
          className="sidebar_btn flex align_items_center flex_gap_5"
          to={`/agent/help`}
        >
          <span className="active_bg_color"></span>
          <span className="sidebar_btn_icon_text">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
              <mask id="mask0_7312_9271" maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="21">
                <rect y="0.5" width="20" height="20" fill="#D9D9D9" />
              </mask>
              <g mask="url(#mask0_7312_9271)">
                <path d="M10.0002 18.4163C8.90516 18.4163 7.87592 18.2086 6.91245 17.793C5.94898 17.3775 5.11092 16.8135 4.39828 16.1011C3.68564 15.3888 3.12141 14.5511 2.70557 13.588C2.28988 12.625 2.08203 11.596 2.08203 10.5011C2.08203 9.40613 2.28981 8.3769 2.70536 7.41342C3.12092 6.44995 3.68488 5.6119 4.39724 4.89926C5.1096 4.18662 5.94731 3.62238 6.91036 3.20655C7.87342 2.79085 8.90238 2.58301 9.99724 2.58301C11.0922 2.58301 12.1215 2.79079 13.0849 3.20634C14.0484 3.6219 14.8865 4.18586 15.5991 4.89822C16.3118 5.61058 16.876 6.44829 17.2918 7.41134C17.7075 8.3744 17.9154 9.40335 17.9154 10.4982C17.9154 11.5932 17.7076 12.6225 17.292 13.5859C16.8765 14.5494 16.3125 15.3875 15.6002 16.1001C14.8878 16.8127 14.0501 17.377 13.087 17.7928C12.124 18.2085 11.095 18.4163 10.0002 18.4163ZM7.58203 16.708L8.80641 13.9195C8.28627 13.7359 7.83731 13.4512 7.45953 13.0655C7.08175 12.6797 6.79356 12.2272 6.59495 11.708L3.77432 12.8747C4.09918 13.7636 4.59495 14.5413 5.26161 15.208C5.92828 15.8747 6.70175 16.3747 7.58203 16.708ZM6.59495 9.29134C6.783 8.77217 7.06745 8.32322 7.44828 7.94447C7.82911 7.56572 8.27648 7.28287 8.79036 7.09592L7.6237 4.2753C6.72953 4.61405 5.94911 5.11676 5.28245 5.78342C4.61578 6.45009 4.11307 7.23051 3.77432 8.12467L6.59495 9.29134ZM9.99682 12.8715C10.6552 12.8715 11.2154 12.6411 11.6774 12.1803C12.1395 11.7195 12.3706 11.1599 12.3706 10.5015C12.3706 9.84322 12.1402 9.28301 11.6793 8.82092C11.2185 8.35884 10.6589 8.1278 10.0006 8.1278C9.34224 8.1278 8.78203 8.35822 8.31995 8.81905C7.85786 9.27988 7.62682 9.83947 7.62682 10.4978C7.62682 11.1561 7.85724 11.7163 8.31807 12.1784C8.77891 12.6405 9.33849 12.8715 9.99682 12.8715ZM12.4154 16.708C13.2904 16.3747 14.0577 15.8781 14.7174 15.2184C15.3772 14.5587 15.8737 13.7913 16.207 12.9163L13.4185 11.692C13.2422 12.2059 12.9629 12.6519 12.5804 13.0301C12.1979 13.4083 11.754 13.6994 11.2487 13.9034L12.4154 16.708ZM13.4024 9.24967L16.207 8.08301C15.8737 7.20801 15.3772 6.44065 14.7174 5.78092C14.0577 5.1212 13.2904 4.62467 12.4154 4.29134L11.2487 7.12155C11.7433 7.31377 12.1749 7.5937 12.5435 7.96134C12.9121 8.32884 13.1984 8.75829 13.4024 9.24967Z" fill="#888888" />
              </g>
            </svg>
            Help
          </span>
        </NavLink>

        <Link
          className="sidebar_btn flex align_items_center flex_gap_5"
          onClick={() => setLogOutPopup(true)}
        >
          <span className="active_bg_color"></span>
          <span className="sidebar_btn_icon_text">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="21"
              viewBox="0 0 20 21"
              fill="none"
            >
              <mask
                id="mask0_6855_7727"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="20"
                height="21"
              >
                <rect y="0.5" width="20" height="20" fill="#D9D9D9" />
              </mask>
              <g mask="url(#mask0_6855_7727)">
                <path
                  d="M10.6182 17.5834C10.441 17.5834 10.2925 17.5236 10.1728 17.4038C10.0532 17.2842 9.99339 17.1358 9.99339 16.9584C9.99339 16.7811 10.0532 16.6326 10.1728 16.513C10.2925 16.3933 10.441 16.3334 10.6182 16.3334H15.5782C15.6423 16.3334 15.7011 16.3067 15.7544 16.2532C15.8079 16.1999 15.8346 16.1411 15.8346 16.077V4.92321C15.8346 4.85904 15.8079 4.80029 15.7544 4.74696C15.7011 4.69348 15.6423 4.66675 15.5782 4.66675H10.6182C10.441 4.66675 10.2925 4.60689 10.1728 4.48716C10.0532 4.36758 9.99339 4.21911 9.99339 4.04175C9.99339 3.86439 10.0532 3.71591 10.1728 3.59633C10.2925 3.47661 10.441 3.41675 10.6182 3.41675H15.5782C15.9992 3.41675 16.3555 3.56258 16.6471 3.85425C16.9388 4.14591 17.0846 4.50223 17.0846 4.92321V16.077C17.0846 16.4979 16.9388 16.8542 16.6471 17.1459C16.3555 17.4376 15.9992 17.5834 15.5782 17.5834H10.6182ZM10.0269 11.1251H3.54297C3.36561 11.1251 3.21714 11.0652 3.09755 10.9455C2.97783 10.8259 2.91797 10.6774 2.91797 10.5001C2.91797 10.3227 2.97783 10.1742 3.09755 10.0547C3.21714 9.93494 3.36561 9.87508 3.54297 9.87508H10.0269L8.42443 8.27258C8.30901 8.15717 8.24998 8.0164 8.24734 7.85029C8.24471 7.68418 8.30373 7.53647 8.42443 7.40716C8.54512 7.27786 8.69151 7.21105 8.86359 7.20675C9.03554 7.20258 9.18616 7.26508 9.31547 7.39425L11.894 9.97279C12.0446 10.1235 12.1198 10.2992 12.1198 10.5001C12.1198 10.7009 12.0446 10.8767 11.894 11.0274L9.31547 13.6059C9.19158 13.7298 9.04443 13.7909 8.87401 13.7892C8.70359 13.7877 8.55373 13.7223 8.42443 13.593C8.30373 13.4637 8.24554 13.3152 8.24984 13.1476C8.25401 12.9798 8.31651 12.8356 8.43734 12.7149L10.0269 11.1251Z"
                  fill="#888888"
                />
              </g>
            </svg>
            Logout
          </span>
        </Link>
      </section>
      {logOutPopup && (
        <div className="bg_back_drop_overlay">
          <div className="bg-white-div p_0">
            <div style={{ height: "150px" }}>
              {" "}
              <img src={logout} alt="logout image" />
            </div>
            <div className="p_15">
              {" "}
              <h4>Confirm Logout</h4>
              <span className="block mt-5">
                Are you sure you want to logout ?
              </span>
              <div className="mt-10 flex align_items_center flex_gap_5">
                <button
                  className="w-half no_logout_btn"
                  onClick={() => setLogOutPopup(false)}
                >
                  No
                </button>
                <button
                  className="w-half vendor_common_property"
                  onClick={handleLogout}
                >
                  Yes
                </button>
              </div>{" "}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AgentSideBar;

{
  /* <NavLink
          className="sidebar_btn flex align_items_center flex_gap_5"
          to={`/agent-profile/${id}`}
        >
          <svg
            className="m_0"
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7.04551 6.54502C6.14832 6.54502 5.38027 6.22557 4.74137 5.58666C4.10246 4.94775 3.78301 4.17971 3.78301 3.28252C3.78301 2.38533 4.10246 1.61729 4.74137 0.978379C5.38027 0.339473 6.14832 0.0200195 7.04551 0.0200195C7.94269 0.0200195 8.71074 0.339473 9.34965 0.978379C9.98855 1.61729 10.308 2.38533 10.308 3.28252C10.308 4.17971 9.98855 4.94775 9.34965 5.58666C8.71074 6.22557 7.94269 6.54502 7.04551 6.54502ZM0.520508 11.4388V10.7863C0.520508 10.3241 0.639453 9.89928 0.877344 9.51186C1.11523 9.12443 1.43129 8.82877 1.82551 8.62486C2.66832 8.20346 3.52473 7.8874 4.39473 7.6767C5.26473 7.466 6.14832 7.36064 7.04551 7.36064C7.94269 7.36064 8.82629 7.466 9.69629 7.6767C10.5663 7.8874 11.4227 8.20346 12.2655 8.62486C12.6597 8.82877 12.9758 9.12443 13.2137 9.51186C13.4516 9.89928 13.5705 10.3241 13.5705 10.7863V11.4388C13.5705 11.8874 13.4108 12.2714 13.0913 12.5908C12.7719 12.9103 12.3879 13.07 11.9393 13.07H2.15176C1.70316 13.07 1.31914 12.9103 0.999687 12.5908C0.680234 12.2714 0.520508 11.8874 0.520508 11.4388ZM2.15176 11.4388H11.9393V10.7863C11.9393 10.6367 11.9019 10.5008 11.8271 10.3785C11.7523 10.2561 11.6538 10.161 11.5314 10.093C10.7974 9.72596 10.0565 9.45068 9.30887 9.26717C8.56121 9.08365 7.80676 8.99189 7.04551 8.99189C6.28426 8.99189 5.5298 9.08365 4.78215 9.26717C4.03449 9.45068 3.29363 9.72596 2.55957 10.093C2.43723 10.161 2.33867 10.2561 2.26391 10.3785C2.18914 10.5008 2.15176 10.6367 2.15176 10.7863V11.4388ZM7.04551 4.91377C7.4941 4.91377 7.87812 4.75404 8.19758 4.43459C8.51703 4.11514 8.67676 3.73111 8.67676 3.28252C8.67676 2.83393 8.51703 2.4499 8.19758 2.13045C7.87812 1.811 7.4941 1.65127 7.04551 1.65127C6.59691 1.65127 6.21289 1.811 5.89344 2.13045C5.57398 2.4499 5.41426 2.83393 5.41426 3.28252C5.41426 3.73111 5.57398 4.11514 5.89344 4.43459C6.21289 4.75404 6.59691 4.91377 7.04551 4.91377Z"
              fill="#000"
            />
          </svg>
          My Profile
        </NavLink> */
}
{
  /* <NavLink
          className="sidebar_btn flex align_items_center  flex_gap_5"
          to={`/agent-packages`}
        >
          <svg
            className="m_0"
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <mask
              id="mask0_3887_4171"
              style={{ maskType: "alpha" }}
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="24"
              height="24"
            >
              <rect width="24" height="24" fill="#D9D9D9" />
            </mask>
            <g mask="url(#mask0_3887_4171)">
              <path
                d="M10.95 18.35L7.4 14.8L8.85 13.35L10.95 15.45L15.15 11.25L16.6 12.7L10.95 18.35ZM5 22C4.45 22 3.97917 21.8042 3.5875 21.4125C3.19583 21.0208 3 20.55 3 20V6C3 5.45 3.19583 4.97917 3.5875 4.5875C3.97917 4.19583 4.45 4 5 4H6V2H8V4H16V2H18V4H19C19.55 4 20.0208 4.19583 20.4125 4.5875C20.8042 4.97917 21 5.45 21 6V20C21 20.55 20.8042 21.0208 20.4125 21.4125C20.0208 21.8042 19.55 22 19 22H5ZM5 20H19V10H5V20ZM5 8H19V6H5V8Z"
                fill="#1C1B1F"
              />
            </g>
          </svg>
          My Packages
        </NavLink> */
}
{
  /* <NavLink
          className="sidebar_btn flex align_items_center flex_gap_5"
          to={`/agent-advance-logs`}
        >
          <svg
          style={{rotate:"180deg"}}
            width="21"
            height="20"
            viewBox="0 0 21 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <mask
              id="mask0_5012_6616"
              style={{ maskType: "alpha" }}
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="21"
              height="20"
            >
              <rect x="0.5" width="20" height="20" fill="#D9D9D9" />
            </mask>
            <g mask="url(#mask0_5012_6616)">
              <path
                d="M3.83329 16.6666C3.37496 16.6666 2.9826 16.5034 2.65621 16.177C2.32982 15.8506 2.16663 15.4583 2.16663 14.9999V4.99992C2.16663 4.54159 2.32982 4.14922 2.65621 3.82284C2.9826 3.49645 3.37496 3.33325 3.83329 3.33325H7.99996V4.99992H3.83329V14.9999H17.1666V4.99992H13V3.33325H17.1666C17.625 3.33325 18.0173 3.49645 18.3437 3.82284C18.6701 4.14922 18.8333 4.54159 18.8333 4.99992V14.9999C18.8333 15.4583 18.6701 15.8506 18.3437 16.177C18.0173 16.5034 17.625 16.6666 17.1666 16.6666H3.83329ZM10.5 12.8333L6.33329 8.66659L7.49996 7.49992L9.66663 9.66658V3.33325H11.3333V9.66658L13.5 7.49992L14.6666 8.66659L10.5 12.8333Z"
                fill="#1C1B1F"
              />
            </g>
          </svg>
          Advance  Payments
        </NavLink> */
}
{
  /* <NavLink
          className="sidebar_btn flex align_items_center flex_gap_5"
          to={`/partner/promotion/${id}`}
        >
          <svg
            className=""
            width="14"
            height="15"
            viewBox="0 0 14 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1.75 14.25C1.3375 14.25 0.984375 14.1031 0.690625 13.8094C0.396875 13.5156 0.25 13.1625 0.25 12.75V2.25C0.25 1.8375 0.396875 1.48438 0.690625 1.19063C0.984375 0.896875 1.3375 0.75 1.75 0.75H7V2.25H1.75V12.75H7V14.25H1.75ZM10 11.25L8.96875 10.1625L10.8813 8.25H4.75V6.75H10.8813L8.96875 4.8375L10 3.75L13.75 7.5L10 11.25Z"
              fill="#000"
            />
          </svg>
          Settings
        </NavLink> */
}
{
  /* <NavLink
          className="sidebar_btn flex align_items_center flex_gap_5 "
          to={`/`}
        >
          <svg
            className=""
            width="14"
            height="15"
            viewBox="0 0 14 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1.75 14.25C1.3375 14.25 0.984375 14.1031 0.690625 13.8094C0.396875 13.5156 0.25 13.1625 0.25 12.75V2.25C0.25 1.8375 0.396875 1.48438 0.690625 1.19063C0.984375 0.896875 1.3375 0.75 1.75 0.75H7V2.25H1.75V12.75H7V14.25H1.75ZM10 11.25L8.96875 10.1625L10.8813 8.25H4.75V6.75H10.8813L8.96875 4.8375L10 3.75L13.75 7.5L10 11.25Z"
              fill="#000"
            />
          </svg>
          Log Out
        </NavLink> */
}

{
  /* <NavLink
          className="sidebar_btn flex align_items_center flex_gap_5"
          to={`/brand-asset`}
        >
          <svg
            className="m_0"
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7.04551 6.54502C6.14832 6.54502 5.38027 6.22557 4.74137 5.58666C4.10246 4.94775 3.78301 4.17971 3.78301 3.28252C3.78301 2.38533 4.10246 1.61729 4.74137 0.978379C5.38027 0.339473 6.14832 0.0200195 7.04551 0.0200195C7.94269 0.0200195 8.71074 0.339473 9.34965 0.978379C9.98855 1.61729 10.308 2.38533 10.308 3.28252C10.308 4.17971 9.98855 4.94775 9.34965 5.58666C8.71074 6.22557 7.94269 6.54502 7.04551 6.54502ZM0.520508 11.4388V10.7863C0.520508 10.3241 0.639453 9.89928 0.877344 9.51186C1.11523 9.12443 1.43129 8.82877 1.82551 8.62486C2.66832 8.20346 3.52473 7.8874 4.39473 7.6767C5.26473 7.466 6.14832 7.36064 7.04551 7.36064C7.94269 7.36064 8.82629 7.466 9.69629 7.6767C10.5663 7.8874 11.4227 8.20346 12.2655 8.62486C12.6597 8.82877 12.9758 9.12443 13.2137 9.51186C13.4516 9.89928 13.5705 10.3241 13.5705 10.7863V11.4388C13.5705 11.8874 13.4108 12.2714 13.0913 12.5908C12.7719 12.9103 12.3879 13.07 11.9393 13.07H2.15176C1.70316 13.07 1.31914 12.9103 0.999687 12.5908C0.680234 12.2714 0.520508 11.8874 0.520508 11.4388ZM2.15176 11.4388H11.9393V10.7863C11.9393 10.6367 11.9019 10.5008 11.8271 10.3785C11.7523 10.2561 11.6538 10.161 11.5314 10.093C10.7974 9.72596 10.0565 9.45068 9.30887 9.26717C8.56121 9.08365 7.80676 8.99189 7.04551 8.99189C6.28426 8.99189 5.5298 9.08365 4.78215 9.26717C4.03449 9.45068 3.29363 9.72596 2.55957 10.093C2.43723 10.161 2.33867 10.2561 2.26391 10.3785C2.18914 10.5008 2.15176 10.6367 2.15176 10.7863V11.4388ZM7.04551 4.91377C7.4941 4.91377 7.87812 4.75404 8.19758 4.43459C8.51703 4.11514 8.67676 3.73111 8.67676 3.28252C8.67676 2.83393 8.51703 2.4499 8.19758 2.13045C7.87812 1.811 7.4941 1.65127 7.04551 1.65127C6.59691 1.65127 6.21289 1.811 5.89344 2.13045C5.57398 2.4499 5.41426 2.83393 5.41426 3.28252C5.41426 3.73111 5.57398 4.11514 5.89344 4.43459C6.21289 4.75404 6.59691 4.91377 7.04551 4.91377Z"
              fill="#000"
            />
          </svg>
          Brand Asset
        </NavLink> */
}
